export default __webpack_public_path__ + "static/media/pbi4.556ba901.JPG";